import { render } from "./MTextArea.vue?vue&type=template&id=e7dfd22a"
import script from "./MTextArea.vue?vue&type=script&lang=js"
export * from "./MTextArea.vue?vue&type=script&lang=js"

import "./MTextArea.vue?vue&type=style&index=0&id=e7dfd22a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__